/* ============================================================================
   c111-medir-run.js  ·  111 Cientonce · 26 ago 2026
   Medidor de prendas de running para el personalizador.
   ---------------------------------------------------------------------------
   POR QUE EXISTE
   assets/c111-medir.js esta hecho para TRISUITS: deduce las zonas buscando la
   entrepierna. En una camisilla o una camiseta no hay entrepierna, asi que
   devolvia null y el personalizador caia al render generico. Resultado: el
   cliente veia una camisilla blanca cualquiera en vez de SU prenda.

   LA REGLA DE NICOLAS
   "En cada prenda, en el frente se usa el render real del producto. En la
   espalda, el generico que mas se parezca; y si no hay generico que se
   parezca, no se personaliza la espalda."

   COMO SE CUMPLE
   · FRENTE -> se mide la foto plana del propio producto (su primera imagen,
     que en 111 es el montaje plano de frente sobre fondo blanco).
   · ESPALDA -> aca siempre se devuelve null a proposito. Asi el personalizador
     cae a BASE.back, que es el generico de camisilla del sexo y color que
     corresponda; y en camiseta y crop top, donde BASE.back es null, la pestana
     de espalda no aparece. Exactamente la regla.

   TRES COSAS QUE COSTARON Y NO HAY QUE DESHACER

   1. El objeto que se devuelve TIENE que traer `img` con la URL. El
      personalizador usa ese objeto tal cual como vista; si falta `img`, la
      etiqueta <img> queda con src "undefined" y no se ve la prenda.

   2. En una CAMISETA no se puede medir el ancho a media altura: ahi se mide de
      manga a manga y el marco sale casi el doble de ancho (el aplique se ve
      enorme). Por eso se busca la caida brusca de ancho donde terminan las
      mangas; el ancho debajo de esa caida es el del cuerpo.

   3. PRENDA BLANCA SOBRE FONDO BLANCO. Con el umbral normal la silueta salia
      partida y el cuerpo medido daba 12% del ancho -> marco de 336 cm y un
      aplique de 12 cm se veia como una pega de 3%. Ahora, si el cuerpo sale
      absurdamente angosto, se repite la medicion con un umbral mas fino. Si
      tampoco da, se devuelve null y cae al generico: mejor el generico
      avisado que una escala mentirosa.

   Barrido del 26 ago sobre las 114 prendas de running: 112 quedaron con render
   real de frente.

   Se carga DESPUES de c111-medir.js y ANTES de c111-personalizador.js.
   ========================================================================== */
(function(){
'use strict';

var nodo = document.getElementById('c111p');
if (!nodo || !window.C111medir) return;
var ref = nodo.getAttribute('data-ref') || '';
if (ref.indexOf('run-') !== 0) return;          /* solo running */

var CM  = parseFloat(nodo.getAttribute('data-cm'))  || 50;
var CAP = parseFloat(nodo.getAttribute('data-cap')) || 18;
var MIN_CUERPO = 0.22;   /* el cuerpo de una prenda nunca ocupa menos del 22% del cuadro */

function carga(url){
  return new Promise(function(ok, fail){
    var i = new Image();
    i.crossOrigin = 'anonymous';
    i.onload = function(){ ok(i); };
    i.onerror = function(){ fail(0); };
    i.src = url.split('?')[0] + '?width=700';
  });
}

function mide(img, url){
  var cw = 420, ch = Math.round(img.naturalHeight / img.naturalWidth * cw);
  var c = document.createElement('canvas'); c.width = cw; c.height = ch;
  var g = c.getContext('2d', { willReadFrequently: true });
  g.drawImage(img, 0, 0, cw, ch);
  var d = g.getImageData(0, 0, cw, ch).data;

  function px(x, y){ var o = (y*cw + x)*4; return [d[o], d[o+1], d[o+2], d[o+3]]; }
  function lum(p){ return p[0]*0.299 + p[1]*0.587 + p[2]*0.114; }

  var esquinas = [px(2,2), px(cw-3,2), px(2,ch-3), px(cw-3,ch-3)];
  var transp = esquinas.every(function(p){ return p[3] < 40; });
  var luces  = esquinas.map(lum);
  var minL = Math.min.apply(null, luces), maxL = Math.max.apply(null, luces);
  if (!transp && !(minL >= 232 && (maxL - minL) < 12)) return null;

  var bg = px(2, 2);

  /* una pasada completa con un umbral dado */
  function pasada(umbral){
    function esPrenda(x, y){
      var p = px(x, y);
      if (bg[3] < 40) return p[3] > 40;
      if (p[3] < 40) return false;
      return Math.abs(p[0]-bg[0]) + Math.abs(p[1]-bg[1]) + Math.abs(p[2]-bg[2]) > umbral;
    }
    var x1 = cw, x2 = 0, y1 = ch, y2 = 0, n = 0;
    for (var y = 0; y < ch; y++){
      for (var x = 0; x < cw; x++){
        if (esPrenda(x, y)){ n++; if (x<x1) x1=x; if (x>x2) x2=x; if (y<y1) y1=y; if (y>y2) y2=y; }
      }
    }
    if (n < 400) return null;
    var alto = y2 - y1, ancho = x2 - x1;
    if (alto / ch < 0.35) return null;
    if (ancho / cw > 0.95) return null;
    var centro = ((x1 + x2) / 2) / cw;
    if (Math.abs(centro - 0.5) > 0.14) return null;

    function anchoEn(fr){
      var yy = Math.round(y1 + alto*fr); if (yy >= ch) yy = ch - 1;
      var a = -1, b = -1;
      for (var x = 0; x < cw; x++){ if (esPrenda(x, yy)){ if (a<0) a = x; b = x; } }
      return a < 0 ? 0 : (b - a) / cw;
    }

    /* ancho del CUERPO, sin mangas: se busca donde el ancho cae de golpe */
    var pasos = [], f;
    for (f = 0.26; f <= 0.741; f += 0.02) pasos.push({ f: +f.toFixed(2), w: anchoEn(f) });
    var cuerpo = anchoEn(0.32);
    for (var i = 1; i < pasos.length; i++){
      var antes = pasos[i-1].w, ahora = pasos[i].w;
      if (antes <= 0) continue;
      if ((antes - ahora) / antes >= 0.18 && pasos[i].f <= 0.62){ cuerpo = ahora; break; }
    }
    return { y1: y1, y2: y2, alto: alto, centro: centro, cuerpo: cuerpo };
  }

  var m = pasada(34);
  /* prenda clara sobre fondo claro: la silueta sale partida y el cuerpo da
     absurdamente angosto. Se reintenta afinando el umbral. */
  if (!m || m.cuerpo < MIN_CUERPO) {
    var m2 = pasada(14);
    if (m2 && m2.cuerpo >= MIN_CUERPO) m = m2;
  }
  if (!m || m.cuerpo < MIN_CUERPO) return null;

  var frameCm = +(CM / m.cuerpo).toFixed(0);
  if (frameCm < 40 || frameCm > 260) return null;

  var zy1 = (m.y1 + m.alto*0.20) / ch * 100;
  var zy2 = (m.y1 + m.alto*0.62) / ch * 100;
  var medio = m.centro * 100;
  var semi = m.cuerpo * 100 * 0.5 * 0.70;

  return {
    img: url,
    ratio: +(ch/cw).toFixed(4),
    zoom: 1,
    frameCm: frameCm,
    zip: null,
    zonas: [{
      k: 'torso', l: 'Torso',
      x1: +(medio - semi).toFixed(1),
      y1: +zy1.toFixed(1),
      x2: +(medio + semi).toFixed(1),
      y2: +zy2.toFixed(1),
      cap: CAP
    }]
  };
}

var cache = {};

window.C111medir.vistaDeUrl = function(url, cara){
  if (cara === 'back') return Promise.resolve(null);
  if (!url) return Promise.resolve(null);
  var clave = url.split('?')[0];
  if (cache[clave] !== undefined) return Promise.resolve(cache[clave]);
  return carga(url).then(function(img){
    var v = null;
    try { v = mide(img, url); } catch(e){ v = null; }
    cache[clave] = v;
    return v;
  }).catch(function(){ cache[clave] = null; return null; });
};

})();